import { nessReviewItem as MShopAppCommunitySTmplNessReviewItem } from '../../../../MShop/App/Community/S/Tmpl/community.js';
import { item as MShopAppProductItemTmplSItem } from '../../../../MShop/App/Product/Item/S/Tmpl/item.js';

export const nessReviewTmpl = MShopAppCommunitySTmplNessReviewItem;
export const productItem = MShopAppProductItemTmplSItem;
